module.exports = __webpack_public_path__ + "static/media/HCMM469.a1ac0563.jpg";